import { keyframes } from '@emotion/react';
export const panelEnter = keyframes({
    from: {
        opacity: 0,
        transform: 'translateY(12px)',
    },
    to: {
        opacity: 1,
        transform: 'translateY(0)',
    },
});
export const panelExit = keyframes({
    from: {
        opacity: 1,
        transform: 'translateY(0)',
    },
    to: {
        opacity: 0,
        transform: 'translateY(0)',
    },
});
